import React from 'react';
import { useDailySettlement } from '@shared/providers/DailySettlementProvider';
import { ClearingStep } from '@widgets/Timeline/components';
import './CurrentCard.scss';

export const CurrentCard: React.FC = () => {
    const { dailySettlement, dailySettlementLoading } = useDailySettlement();

    if (dailySettlementLoading && !dailySettlement) return null;

    const currentStep = dailySettlement?.actionStatuses[dailySettlement?.actionStatuses.length - 1];

    return (
        <div className={'widget-current-card'}>
            <div className={'widget-current-card--header'}>
                <h6>Clearing</h6>
                {currentStep?.status && <ClearingStep currentSettlement={currentStep} />}
            </div>
            <div className={'widget-current-card--steps'}>
                <p>Step: {currentStep?.name}</p>
                <div className={'widget-current-card--steps-chart'}>
                    {dailySettlement?.actionStatuses.map((step, i) => <div key={i} />)}
                </div>
            </div>
        </div>
    );
};
